<template>
  <div style="padding: 0 10px;">
    <From @search="searchCall" />
    <WmsTable :columns="columns" :dataSource="dataSource" @pageChange="pageChangeCall" :isPagination="query" >
      <div slot="regionName" slot-scope="{text, record, index}">{{regionFlag(text)}}</div>
      <ImgView slot="productImgAction" slot-scope="{text, record, index}" :src="text"></ImgView>
    </WmsTable>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
import From from "@/views/inventoryDetails/discard/components/From";
import { columns } from "@/views/inventoryDetails/discard/indexData";
import { RegionList, pkgPage } from "@/apis/inventoryDetails";

export default {
  title: "废弃件",
  name: "Discard",
  components: {
    WmsTable,
    ImgView,
    From
  },
  data() {
    return {
      columns,
      query: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      dataSource: [],
      regionList: [],
    }
  },
  mounted() {
    this.getRegion();
  },
  methods: {
    searchCall: function (fromData) {
      this.formInline = fromData;
      this.query.current = 1;
      this.query.total = 1;
      this.getDataSource();
    },
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    getDataSource: function () {
      let params = {
        // checkingShelvFlag: 1,
        // combinationProductItemFlag: 1,
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        pkgOwn: 2,
        ...this.formInline,
      };
      if (params.pkgType && params.pkgType != "") {
        params.pkgType = [params.pkgType];
      }
      pkgPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data.records;
          this.query.total = data.total;
        }
      });
    },
    getRegion() {
      let params = {
        pageNum: 1,
        pageSize: 99,
      };
      RegionList(params).then(({ code, data }) => {
        if (code === 0) {
          this.regionList = data;
        }
      });
    },
    regionFlag(region) {
      let text = ''
      this.regionList.map((item) => {
        if (region === item.regionCode) {
          text = item.regionName;
        }
      });
      return text
    },
  }
}
</script>

<style scoped>
</style>